import React from 'react';
import { Linkedin, ArrowUp, Facebook, Instagram } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from 'react-icons/fa';

export default function FooterSub() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToSection = (href) => {
    if (href.startsWith("/")) {
      navigate(href);
      return;
    }

    const element = document.querySelector(href);

    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
    }

  };
  const quickLinks = [
    { label: "About Us", href: "/" },
    { label: "What We Do", href: "/" },
    { label: "Careers", href: "/" },
    { label: "Contact", href: "/" },
  ];


  return (
    <footer className="bg-primary text-primary-foreground py-8 sm:py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-center mb-6 sm:mb-8">
          {/* Copyright */}
          <div className="text-center md:text-left">
            <p className="text-sm text-primary-foreground/70">
              © 2026 Brion Enterprises LLP. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-6">
            {quickLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Social & Back to Top */}
          <div className="flex items-center justify-center md:justify-end gap-4">
            <a
              href="https://www.linkedin.com/company/brionenterprises/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61591606966051"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Facebook className="h-5 w-5" />

            </a>
            <a
              href="https://wa.me/918433711334"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <FaWhatsapp className="h-5 w-5" />

            </a>
            <a
              href="https://www.instagram.com/brionenterprises.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
            >
              <Instagram className="h-5 w-5" />

            </a>


            <Button
              variant="ghost"
              size="icon"
              onClick={scrollToTop}
            >
              <ArrowUp className="h-5 w-5" />
            </Button>

          </div>
        </div>
        {/* Disclaimers */}
        <div className="border-t border-primary-foreground/20 pt-8 space-y-4 text-center">
          <p className="text-xs text-primary-foreground/60 leading-relaxed">
            Brion Enterprises LLP invests using its own capital. The firm does not solicit or accept public funds and does not provide investment advisory or portfolio management services.
          </p>
          <p className="text-xs text-primary-foreground/60 leading-relaxed">
            Investment in securities markets are subject to market risks. Read all related documents carefully before investing.
          </p>
          <p className="text-xs text-primary-foreground/60 leading-relaxed">
            AP of Marwadi Shares and Finance Limited.</p>
        </div>
      </div>
    </footer>
  );
}